import { gql, useMutation } from '@apollo/client';

import { GET_CONSULTANT_NUMBERS } from './get-consultant-numbers.hook';

export const DELETE_CONSULTANT_NUMBER = gql`
  mutation deleteConsultantNumber($consultantNumberId: ObjectId!) {
    deleteConsultantNumber(consultantNumberId: $consultantNumberId) {
      _id
    }
  }
`;

export const useDeleteConsultantNumber = ({ onSuccess }: { onSuccess: () => void }) => {
  const [deleteConsultantNumber] = useMutation(DELETE_CONSULTANT_NUMBER, {
    refetchQueries: [GET_CONSULTANT_NUMBERS],
    onCompleted: onSuccess,
  });

  return { deleteConsultantNumber };
};
